import { ColorBlindMode, ISettings, Units } from '../../models/Settings';
import { ActionType } from '../action-types';
import { Action } from '../actions';

const initialState: ISettings = {
	units: Units.Metric,
	colorBlindMode: ColorBlindMode.Off,
	shortcutsEnabled: true,
};

const reducer = (state: ISettings = initialState, action: Action): ISettings => {
	// TODO: Add actions
	switch (action.type) {
		case ActionType.SET_UNITS: {
			return {
				...state,
				units: action.payload.units,
			};
		}
		case ActionType.SET_SHORTCUTS_ENABLED: {
			return {
				...state,
				shortcutsEnabled: action.payload.newValue,
			};
		}
		case ActionType.RESET_STATE: {
			return initialState;
		}
		default:
			return state;
	}
};

export default reducer;
